import { ButtonLink, ButtonLinkNoBorder } from '../styles'

interface ValidateLinkActionsProps {
  cancelAction?: () => void
  rescheduleAction?: () => void
  evalueteAction?: () => void
  onMyPrescription?: () => void
  withPrescription?: boolean
}

export const useValidateActions = (status: string, isFinished: boolean, withNps: boolean) => {
  const statusValidate = !!(status === 'paid' || status === 'waiting_appointment')
  const validatePayment = !!(status === 'waiting_payment' || status === 'created')
  const validateButtonActions = () => {
    if (isFinished) {
      return {
        color: '#4E4E4E',
        text: 'novo agendamento'
      }
    }
    if (statusValidate) {
      return {
        color: '#4380E6',
        text: 'acessar consulta'
      }
    }
    if (validatePayment) {
      return {
        color: '#F0780A',
        text: 'efetuar o pagamento'
      }
    }
    return {
      color: '#4E4E4E',
      text: 'novo agendamento'
    }
  }

  function ValidateLinkActions({
    rescheduleAction,
    cancelAction,
    evalueteAction,
    onMyPrescription,
    withPrescription
  }: ValidateLinkActionsProps) {
    if (status === 'canceled') {
      return null // Consulta cancelada não mostra botões
    }

    // Para todas as outras consultas, mostrar reagendar e avaliar
    return (
      <div className="box_link">
        {rescheduleAction && <ButtonLink onClick={rescheduleAction}>reagendar</ButtonLink>}
        {evalueteAction && <ButtonLinkNoBorder onClick={evalueteAction}>Avaliar</ButtonLinkNoBorder>}
      </div>
    )
  }

  const ButtonProps = {
    color: validateButtonActions().color,
    text: validateButtonActions().text
  }

  return { ButtonProps, ValidateLinkActions }
}
